export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    allItems: (state) => state.items,
    cntItems: (state) => state.items.length,
    itemInCart: (state) => (cartId) =>
      state.items.some((item) => item.id === cartId),
    productInCart: (state) => (productId) =>
      state.items.some((item) => item.productId === productId),
    cartItemByProductId: (state) => (productId) =>
        state.items.find((item) => item.productId === productId),
  },
  mutations: {
    add(state, item) {
      state.items.push(item);
    },
    remove(state, cartId) {
      state.items = state.items.filter((item) => item.id !== cartId);
    },
    quantity(state, { cartId, quantity }) {
      let item = state.items.find((item) => item.id === cartId);
      item.quantity = quantity;
    },
    load(state, cartItems) {
      state.items = cartItems;
    },
  },
  actions: {
    async load({ commit }) {
      try {
        let response = await fetch("/api/cart/items/");
        let result = await response.json();
        commit("load", result.data.items);
      } catch (e) {
        alert(e);
      }
    },
    async add({ commit, getters }, { productId, quantity, params = [] }) {
      if (!getters.productInCart(productId)) {
        try {
          let formData = new FormData();

          if (params['typePrintFile']) {
            console.log(params)
            console.log(params['typePrintFile'])
            console.log(params['typePrintFile'][0])
            formData.append("typePrintFile[0]", params['typePrintFile'][0]);
            params['typePrintFile'] = false;
          }

          formData.append("productId", productId);
          formData.append("quantity", quantity);
          formData.append("params", JSON.stringify(params));
          let response = await fetch("/api/cart/add/", {
            method: "POST",
            body: formData,
          });
          let result = await response.json();
          if (result.success) {
            commit("add", result.data);
          }
        } catch (e) {
          alert(e);
        }
      }
    },
    async remove({ commit, getters }, cartId) {
      if (getters.itemInCart(cartId)) {
        try {
          let formData = new FormData();
          formData.append("cartId", cartId);
          let response = await fetch("/api/cart/remove/", {
            method: "POST",
            body: formData,
          });
          let result = await response.json();
          if (result.success) {
            commit("remove", cartId);
          }
        } catch (e) {
          alert(e);
        }
      }
    },
    async quantity({ commit, getters }, { cartId, quantity }) {
      if (getters.itemInCart(cartId)) {
        try {
          let formData = new FormData();
          formData.append("cartId", cartId);
          formData.append("quantity", quantity);
          let response = await fetch("/api/cart/quantity/", {
            method: "POST",
            body: formData,
          });
          let result = await response.json();
          if (result.success) {
            commit("quantity", { cartId, quantity });
          }
        } catch (e) {
          alert(e);
        }
      }
    },
  },
};
